<template>
  <div
    class="container-fluid pl-0 pr-0"
    style="background: #f9f9fb 0% 0% no-repeat padding-box; opacity: 1"
  >
    <div
      style="background-color: #78de87; opacity: 1; height: 50px"
      v-if="showSnackbar"
    >
      <div
        class="d-flex justify-content-center"
        style="padding-top: 14px; line-height: 22px; color: #000"
      >
        In order to access more information please Login or Sign Up
      </div>
    </div>
    <div style="background-color: #5445f3; height: 50px">
      <div class="d-flex topLayout">
        <div class="flex-grow-1 fiifiIcon">fiifi</div>
        <div class="d-flex">
          <div
            class="loginText"
            style="color: #fff; cursor: pointer"
            @click="
              shareCompanyModalShow = true;
              refreshForm = true;
            "
          >
            Share
          </div>
          <div class="loginText">
            <a :href="loginUrl" style="color: #fff" target="_blank">Login</a>
          </div>
          <div class="buttonLayout">
            <a :href="signupUrl" style="color: #434343" target="_blank"
              >Get fiifi free</a
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="row mr-0"
      style="
        margin-top: 50px;
        margin-bottom: 25px;
        margin-left: 139px;
        max-width: 1440px;
      "
    >
      <div class="d-flex col-md-12 pl-0 pr-0">
        <div class="col-md-9 pl-0" style="padding-right: 12px">
          <div class="d-flex flex-wrap">
            <div class="col-md-4 borderClass">
              <div style="padding-left: 15px; padding-right: 15px">
                <div class="d-flex company-profile-top">
                  <div class="company-profile-top-parent">
                    <div
                      :style="statusBadge.style"
                      class="company-profile-badge"
                    >
                      <span class="companyProfileStatusBadgeValue">{{
                        statusBadge.value
                      }}</span>
                    </div>
                    <span style="flex: 1 1 auto"></span>
                  </div>
                  <div class="flex-grow-1" style="text-align: center">
                    <img
                      v-bind:src="getCompanyImageUrl"
                      :alt="company.name"
                      :title="company.name"
                      class="rounded-circle"
                      style="width: 120px; height: 120px"
                    />
                  </div>
                </div>
                <div style="text-align: center">
                  <div class="company-profile-name">{{ name }}</div>
                  <div class="company-profile-sector">
                    {{ filterCategoryData }}
                  </div>
                </div>
                <div style="padding-bottom: 20px" class>
                  <table class="portfolio-company-left-table-data">
                    <tr v-for="field in companyTableFields" :key="field.label">
                      <th>{{ field.label }}</th>
                      <td
                        v-if="
                          field.label == 'Website:' ||
                          field.label == 'Contact Email:' ||
                          field.label == 'Social Media:'
                        "
                        @click="showSnackbar = true"
                      >
                        <span
                          style="
                            line-height: 1.5;
                            display: inline-block;
                            max-width: 100%;
                            cursor: pointer;
                          "
                          v-html="field.value"
                          >{{}}</span
                        >
                      </td>
                      <td v-else>
                        <span
                          style="
                            line-height: 1.5;
                            display: inline-block;
                            max-width: 100%;
                          "
                          v-html="field.value"
                          >{{}}</span
                        >
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-md-8 borderClass">
              <div
                class="row mr-0 ml-0"
                style="padding-left: 9px; padding-right: 9px; padding-top: 39px"
              >
                <div class="col-md-12 pl-0 pr-0">
                  <div class="companyDescriptionTitle">Company Description</div>
                  <div class="companyDescriptionData">
                    {{ description }}
                    <span
                      v-if="description"
                      class="contactsMore"
                      @click="showSnackbar = true"
                      style="cursor: pointer"
                      >more</span
                    >
                  </div>
                </div>
                <div
                  class="col-md-6 pl-0 pr-0"
                  style="margin-top: 30px"
                  v-if="founders.length > 0"
                >
                  <div class="contactsTitle" v-if="founders.length > 0">
                    Founders
                  </div>
                  <div
                    class="contactsTitle"
                    v-if="founders.length == 0"
                    style="color: #676767 !important"
                  >
                    Founders
                  </div>
                  <div v-if="founderArray && founderArray.length > 0">
                    <div
                      class="d-flex"
                      style="padding-bottom: 10px"
                      v-for="(item, index) in founderArray"
                      :key="index"
                    >
                      <div style="padding-right: 8px">
                        <img
                          v-bind:src="getPeopleImageUrl(item)"
                          :alt="item.name"
                          :title="item.name"
                          width="20"
                          height="20"
                          class="rounded-circle"
                        />
                      </div>
                      <div class="contactsName">{{ item.name }}</div>
                    </div>
                    <div
                      v-if="founders.length > 2 && founderArray.length == 2"
                      class="contactsMore"
                      title="Login to see more"
                      @click="showSnackbar = true"
                    >
                      {{ founders.length - 2 }} more
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-6 pl-0 pr-0"
                  style="margin-top: 30px"
                  v-if="advisors.length > 0"
                >
                  <div class="contactsTitle" v-if="advisors.length > 0">
                    Advisors
                  </div>
                  <div
                    class="contactsTitle"
                    v-if="advisors.length == 0"
                    style="color: #676767 !important"
                  >
                    Advisors
                  </div>
                  <div v-if="advisorArray && advisorArray.length > 0">
                    <div
                      class="d-flex"
                      style="padding-bottom: 10px"
                      v-for="(item, index) in advisorArray"
                      :key="index"
                    >
                      <div style="padding-right: 8px">
                        <img
                          v-bind:src="getPeopleImageUrl(item)"
                          :alt="item.person_name"
                          :title="item.person_name"
                          width="20"
                          height="20"
                          class="rounded-circle"
                        />
                      </div>
                      <div class="contactsName">{{ item.person_name }}</div>
                    </div>
                    <div
                      v-if="advisors.length > 2 && advisorArray.length == 2"
                      class="contactsMore"
                      @click="showSnackbar = true"
                      title="Login to see more"
                    >
                      {{ advisors.length - 2 }} more
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-6 pl-0 pr-0"
                  style="margin-top: 30px; margin-bottom: 20px"
                  v-if="investors.length > 0"
                >
                  <div class="contactsTitle" v-if="investors.length > 0">
                    Investors
                  </div>
                  <div
                    class="contactsTitle"
                    v-if="investors[0].list.length == 0"
                    style="color: #676767 !important"
                  >
                    Investors
                  </div>
                  <div v-if="investorArray && investorArray.length > 0">
                    <div
                      class="d-flex"
                      style="padding-bottom: 10px"
                      v-for="(item, index) in investorArray"
                      :key="index"
                    >
                      <div style="padding-right: 8px">
                        <img
                          v-bind:src="getPeopleImageUrl(item)"
                          :alt="item.investor_name"
                          :title="item.investor_name"
                          width="20"
                          height="20"
                          class="rounded-circle"
                        />
                      </div>
                      <div class="contactsName">{{ item.investor_name }}</div>
                    </div>
                    <div
                      v-if="
                        investors[0].list.length > 2 &&
                        investorArray.length == 2
                      "
                      class="contactsMore"
                      title="Login to see more"
                      @click="showSnackbar = true"
                    >
                      {{ investors[0].list.length - 2 }} more
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-6 pl-0 pr-0"
                  style="margin-top: 30px; margin-bottom: 20px"
                  v-if="employees.length > 0"
                >
                  <div class="contactsTitle" v-if="employees.length > 0">
                    Employees
                  </div>
                  <div
                    class="contactsTitle"
                    v-if="employees.length == 0"
                    style="color: #676767 !important"
                  >
                    Employees
                  </div>
                  <div v-if="employeeArray && employeeArray.length > 0">
                    <div
                      class="d-flex"
                      style="padding-bottom: 10px"
                      v-for="(item, index) in employeeArray"
                      :key="index"
                    >
                      <div style="padding-right: 8px">
                        <img
                          v-bind:src="getPeopleImageUrl(item)"
                          :alt="item.name"
                          :title="item.name"
                          width="20"
                          height="20"
                          class="rounded-circle"
                        />
                      </div>
                      <div class="contactsName">{{ item.name }}</div>
                    </div>
                    <div
                      v-if="employees.length > 2 && employeeArray.length == 2"
                      class="contactsMore"
                      title="Login to see more"
                      @click="showSnackbar = true"
                    >
                      {{ employees.length - 2 }} more
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex" style="margin-top: 25px">
            <div class="col-md-12 pl-0 pr-0">
              <div
                id="fundingRounds"
                class="todos-table-parent companyProfileTabulatorLayout fundingRoundsLayout"
              >
                <div class>
                  <div class="companyProfileTabulatorTitle">Funding Rounds</div>
                  <div class="companyProfileTabulatorTitleBorderLine"></div>
                </div>
                <div id="fundingRoundsTable">
                  <div class="tabulator" ref="fundingRoundsTable"></div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex" style="margin-top: 25px" v-if="portfolioChecklist && portfolioChecklist.length">
            <div class="col-md-12 pl-0 pr-0">
              <div
                id="fundingRounds"
                class="todos-table-parent companyProfileTabulatorLayout fundingRoundsLayout"
              >
                <div class>
                  <div class="companyProfileTabulatorTitle">Checklist</div>
                  <!-- <div class="companyProfileTabulatorTitleBorderLine">{{checklist.name}}</div> -->
                </div>
                <div>
                  <div>
                    <div
                    v-for="(checklist, idx) in portfolioChecklist"
                  :key="idx"
                  style="margin-top: 20px;"
                  >
                      <div class="checklist-name">{{checklist.name}}</div>
                      <div class="checklist-description">
                        {{checklist.description}}
                      </div>
                      <div 
                       v-for="(item, idx2) in checklist.checklist_items"
                  :key="idx2">
                        <div
                          class="flex-row"
                          style="
                            align-items: center;
                            display: flex;
                            margin-top: 15px;
                            margin-bottom: 10px;
                          "
                        >
                          <i class="fa fa-square-o" v-if="!item.is_done"></i>
                          <i class="fa fa-check-square" v-if="item.is_done"></i>
                          <div v-html="item.summary" class="task"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="col-md-3"
          @click="showSnackbar = true"
          style="cursor: pointer"
        >
          <img
            src="/static/img/fiifi-poster-1.png"
            width="320"
            style="height: 100%"
          />
        </div>
      </div>
    </div>
    <el-dialog
      left
      title="Share Company"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      width="500px"
      style="margin: 0 auto"
      :visible.sync="shareCompanyModalShow"
      @close="
        sharingNote = '';
        tags = [];
        refreshForm = false;
      "
    >
      <div>
        <div>Email</div>
        <b-form-group :state="state" label-for="tags-validation">
          <b-form-tags
            input-id="tags-validation"
            :input-attrs="{ 'aria-describedby': 'tags-validation-help' }"
            v-model="tags"
            v-if="refreshForm"
            :state="state"
            placeholder="Enter Emails separated by comma"
            tag-variant="primary"
            invalid-tag-text="Invalid email(s)"
            duplicate-tag-text="Duplicate email(s)"
            tag-pills
            add-on-change
            :tag-validator="tagValidator"
            @tag-state="onTagState"
            separator=","
          ></b-form-tags>
        </b-form-group>
        <div>Notes</div>
        <textarea
          placeholder="Notes"
          rows="5"
          cols="50"
          class="form-control"
          spellcheck="false"
          v-model="sharingNote"
        ></textarea>
        <div class="d-flex py-3" style="margin: 0px; justify-content: flex-end">
          <button
            type="button"
            @click="shareCompanyModalShow = !shareCompanyModalShow"
            class="todo-form-cancel-button btn-outline-secondary"
            style="margin-right: 10px"
          >
            Cancel
          </button>
          <button
            type="button"
            @click.prevent="sendEmail"
            :disabled="emailCheck || SharingCompanySubmit"
            class="btn btn-info btn-fill btn-wd"
            style="
              height: 35px;
              font-size: 14px;
              line-height: 17px;
              font-family: custom-helvetica-medium, roboto;
            "
          >
            Send
            <b-spinner
              v-if="SharingCompanySubmit"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </div>
    </el-dialog>
    <!-- <el-dialog
      left
      title="Share Company"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      :showClose="true"
      width="500px"
      @close="sharingNote='';tags=[];refreshForm=false"
      :visible.sync="shareCompanyModalShow"
      
    ></el-dialog>-->
  </div>
</template>
<script>
import config from "../../config/settings";
import Tabulator from "tabulator-tables";
import { Dialog } from "element-ui";
import company from "../../../site_main/src/store/modules/fake/company";
export default {
  components: {
    [Dialog.name]: Dialog,
  },
  data() {
    return {
      permalink: "",
      name: "",
      description: "",
      company: {},
      loginUrl: "",
      signupUrl: "",
      tabulator: null,
      advisorArray: [],
      founderArray: [],
      employeeArray: [],
      investorArray: [],
      founders: [],
      advisors: [],
      investors: [],
      employees: [],
      shareCompanyModalShow: false,
      refreshForm: false,
      sharingNote: "",
      tags: [],
      validTags: [],
      invalidTags: [],
      duplicateTags: [],
      SharingCompanySubmit: false,
      showSnackbar: false,
      currentStage: "",
      lastFundingRound: "",

      portfolioChecklist: []
    };
  },
  computed: {
    config() {
      return config;
    },
    filterCategoryData() {
      if (this.company.category_data) {
        let categoryData = this.company.category_data;
        categoryData = categoryData.split(",");
        return Array.from(new Set(categoryData)).toString();
      } else {
        return;
      }
    },
    companyTableFields() {
      this.company.sector =
        this.company.sector == "" || this.company.sector == "Unknown"
          ? "-"
          : this.company.sector;
      this.company.stage_i_invested = this.company.stage_i_invested
        ? this.company.stage_i_invested
        : "-";
      this.company.founding_date = this.company.founding_date
        ? this.company.founding_date
        : "-";
      this.company.initial_investment = this.company.initial_investment
        ? this.company.initial_investment
        : "-";
      this.company.estimated_revenue_range =
        this.company.estimated_revenue_range || "-";
      this.company.direct = this.company.direct ? this.company.direct : "-";
      this.company.ipo_status = this.company.ipo_status
        ? this.company.ipo_status
        : "-";
      this.company.fund =
        this.company.fund || this.company.fund != "" ? this.company.fund : "-";
      this.company.status = this.company.status
        ? this.company.status
        : "Unknown";
      this.company.category_data = this.company.category_data
        ? this.company.category_data
        : "-";
      this.company.headquarters = this.company.headquarters
        ? this.company.headquarters
        : "-";
      this.company.geography =
        this.company.geography && this.company.geography != "Unspecified"
          ? this.company.geography
          : "-";
      this.company.website = this.company.website ? this.company.website : "-";
      this.company.facebook = this.company.facebook
        ? this.company.facebook
        : "-";
      this.company.linkedin = this.company.linkedin
        ? this.company.linkedin
        : "-";
      this.company.twitter = this.company.twitter ? this.company.twitter : "-";
      this.company.contact_email = this.company.contact_email
        ? this.company.contact_email
        : "-";
      this.company.lastFunding = this.company.last_funding_round
        ? this.company.last_funding_round
        : "-";
      return [
        {
          label: "Founding Date:",
          value:
            // this.company.founding_date &&
            // this.company.founding_date != "-" &&
            // this.company.founding_date != "Invalid date"
            //   ? moment(this.company.founding_date).format("MM/DD/YYYY")
            //   : "-",
            this.company.founding_date &&
            this.company.founding_date != "-" &&
            this.company.founding_date != "Invalid date"
              ? this.company.founding_date
              : "-",
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Last Funding Round:",
          value: this.lastFundingRound,
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Current Stage:",
          value: this.currentStage,
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Geography:",
          value: this.company.geography,
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Headquarters:",
          value: this.company.headquarters,
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "No. of Employees:",
          value: this.company.employee_count || "-",
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Website:",
          value:
            this.company.website && this.company.website != "-"
              ? `<a class="link">${this.company.website}</a>`
              : "-",
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Contact Email:",
          value:
            this.company.contact_email && this.company.contact_email != "-"
              ? `<a class="link" style="color: #0000009A;">${this.company.contact_email}</a>`
              : "-",
          isEditOn: false,
          isEditable: false,
        },
        {
          label: "Social Media:",
          value: this.socialMedia,
          isEditOn: false,
          isEditable: false,
        },
      ];
    },
    socialMedia() {
      let html = "";
      if (
        (this.company.facebook && this.company.facebook != "-") ||
        (this.company.linkedin && this.company.linkedin != "-") ||
        (this.company.twitter && this.company.twitter != "-")
      ) {
        html = `<div class="d-flex">
          <div>
          <a class="link"   style="color: #0000009A;font-size: 18px;padding-right: 5px;">
          <i class="fa fa-facebook-square" aria-hidden="true"></i>
          </a>
          </div>
           <div>
          <a class="link"   style="color: #0000009A;font-size: 18px;padding-right: 5px;">
          <i class="fa fa-linkedin-square" aria-hidden="true"></i>
          </a> 
          </div>
           <div>
          <a class="link"   style="color: #0000009A;font-size: 18px;padding-right: 5px;">
          <i class="fa fa-twitter-square" aria-hidden="true"></i>
          </a>
          </div>
          </div>`;
      } else {
        html = `<div style="color:#0000009A;font-size:18px">-</div>`;
      }
      return html;
    },
    statusBadge() {
      let obj = {};
      this.company.company_status = this.company.company_status
        ? this.company.company_status
        : "Unknown";
      obj.value = this.company.company_status;
      if (
        this.company.company_status == "Active" ||
        this.company.company_status == "Unknown" ||
        this.company.company_status == "Mentor"
      ) {
        obj.style =
          "margin-top:2px;background: #CBF6C5 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      } else if (this.company.company_status == "Out of Business") {
        obj.value = "OB";
        obj.style =
          "margin-top:2px;background: #FACCCC 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      } else if (this.company.company_status == "IPO") {
        obj.style =
          "margin-top:2px;background: #FFDFB4 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      } else if (this.company.company_status == "Acquired") {
        obj.style =
          "margin-top:2px;background: #B4DCFF 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      } else {
        obj.style =
          "margin-top:2px;background: #FFDFB4 0% 0% no-repeat padding-box;border-radius: 10px;opacity: 1;";
      }
      return obj;
    },
    state() {
      return this.dirty ? this.tags.length > 0 && this.tags.length < 10 : null;
    },
    emailCheck() {
      if (this.tags.length > 0 && this.invalidTags.length == 0) return false;
      else return true;
    },
    getCompanyImageUrl() {
      return this.company &&
        this.company.hasOwnProperty("image_id") &&
        this.company.image_id.length > 0
        ? `${config.CRUNCHBASE_IMAGE_URL}/${this.company.image_id}`
        : this.company.logo && this.company.logo.length > 0
        ? this.company.logo
        : "/static/img/generic-logo.png";
    },
  },
  mounted() {
    this.permalink = this.$route.params.permalink;
    if (this.$route.query && this.$route.query.a) {
      this.loginUrl = `${config.cred.oauth.redirectSignOut}?per=${this.permalink}&a=${this.$route.query.a}&c=${this.$route.query.c}`;
      this.signupUrl = `${config.cred.oauth.redirectSignUp}?per=${this.permalink}&a=${this.$route.query.a}&c=${this.$route.query.c}`;
    } else {
      this.loginUrl = `${config.cred.oauth.redirectSignOut}?per=${this.permalink}`;
      this.signupUrl = `${config.cred.oauth.redirectSignUp}?per=${this.permalink}`;
    }

    this.getChecklist();

    let url = `${config.API_URL}/public/co/name/${this.permalink}`;
    let self = this;
    fetch(url, {})
      .then((response) => response.json())
      .then((data) => {
        self.name = data.success.name;
        self.description = data.success.description;
        let metaDesc;
        if (data.success.description) {
          metaDesc =
            data.success.description.length > 159
              ? data.success.description.substring(0, 159)
              : data.success.description;
        }
        const descEl = document.querySelector('head meta[name="description"]');
        const titleEl = document.querySelector("head title");

        descEl.setAttribute("content", metaDesc);
        titleEl.textContent = `Fiifi | ${data.success.name}`;
      });
    let companyUrl = `${config.API_URL}/public/co/all/${this.permalink}`;
    fetch(companyUrl, {})
      .then((response) => response.json())
      .then((data) => {
        self.company = data.success;
        let fundingRounds =
          data.success.funding.length > 0 ? data.success.funding[0].list : [];
        self.currentStage =
          data.success.funding.length > 0 &&
          data.success.funding[0].list &&
          data.success.funding[0].list.length > 0
            ? data.success.funding[0].list[0].transaction_name
            : "-";
        self.lastFundingRound =
          data.success.funding.length > 0 &&
          data.success.funding[0].list &&
          data.success.funding[0].list.length > 0
            ? data.success.funding[0].list[0].announced_date
            : "-";
        self.tabulator = new Tabulator(
          self.$refs.fundingRoundsTable,
          self.fundingRoundOptions(fundingRounds)
        );
        self.founders = data.success.founders;
        self.investors = data.success.investors;
        self.advisors = data.success.advisors;
        self.employees = data.success.employees;
        self.contacts();
      });
  },
  methods: {
    fundingRoundOptions(array) {
      const self = this;
      const DATA_STATUS_UNCONFIRMED = "Unconfirmed";
      const DATA_STATUS_UPDATING = "Retrieving";
      const DATA_STATUS_CONFIRMED = "Confirmed";
      return {
        data:
          array.length > 5
            ? [array[0], array[1], array[2], array[3], array[4]]
            : array,
        minHeight: 100,
        layout: "fitColumns",
        layoutColumnsOnNewData: true,
        tooltips: true,
        //pagination: "local",
        tooltipsHeader: true,
        placeholder: "No records to view",
        columns: [
          {
            title: "Funding",
            field: "funding_status",
            sorter: "string",
            //width: 80,
            resizable: true,
          },
          {
            title: "Verified",
            field: "data_status",
            sorter: "string",
            resizable: true,
            //width: "70",
            formatter: function (cell, formatterParams) {
              switch (cell.getData().data_status) {
                case DATA_STATUS_CONFIRMED:
                  return `
                  <span  class="success-data-status">
                    <i class=" nc-icon nc-check-2"></i>
                  </span>`;
                  break;
                case DATA_STATUS_UNCONFIRMED:
                  return `
                  <span  class="warn-data-status">
                  <i class="nc-icon ">!</i>
                  </span>`;
                  break;
                case DATA_STATUS_UPDATING:
                  return `
                  <span  class="normal-data-status">
                  <i class="nc-icon nc-refresh-02 spinner "></i>
                  </span>`;
                  break;
              }
              return "-";
            },
          },
          {
            title: "Round",
            field: "funding_type",
            sorter: "string",
            //width: 100,
            resizable: true,
          },
          {
            title: "Closing Date",
            field: "announced_date",
            sorter: "date",
            // width: 150,
            resizable: true,
            // formatter: function(cell, formatterParams) {
            //   return moment(cell.getData().announced_date).format("MM/DD/YYYY");
            // }
          },
          {
            title: "Total Raised",
            field: "money_raised",
            sorter: "string",
            // width: 150,
            resizable: true,
          },
          {
            title: "Investors",
            field: "number_of_investors",
            sorter: "number",
            //width: 150,
            resizable: true,
          },
          {
            title: "Lead Investors",
            field: "lead_investors",
            sorter: "string",
            //width: 160,
            resizable: true,
          },
          // { title: "Shares", field: "shares", sorter: "string", resizable: true }
        ],
      };
    },
    contacts() {
      let self = this;
      if (self.founders) {
        self.founderArray =
          self.founders.length > 1
            ? [self.founders[0], self.founders[1]]
            : self.founders;
      }
      if (self.investors && self.investors && self.investors[0].list) {
        self.investorArray =
          self.investors[0].list.length > 1
            ? [self.investors[0].list[0], self.investors[0].list[1]]
            : self.investors[0].list;
      }
      if (self.advisors) {
        self.advisorArray =
          self.advisors.length > 1
            ? [self.advisors[0], self.advisors[1]]
            : self.advisors;
      }
      if (self.employees) {
        self.employeeArray =
          self.employees.length > 1
            ? [self.employees[0], self.employees[1]]
            : self.employees;
      }
    },
    tagValidator(tag) {
      let value = tag.length > 5 && tag.includes("@") && tag.includes(".");
      return value;
    },
    onTagState(valid, invalid, duplicate) {
      this.validTags = valid;
      this.invalidTags = invalid;
      this.duplicateTags = duplicate;
    },
    sendEmail() {
      this.SharingCompanySubmit = true;
      let serverData = {};
      serverData.emails = this.tags;
      serverData.note = this.sharingNote;
      serverData.permalink = this.permalink;
      serverData.component = "Portfolio link from public url";
      serverData.company = this.name;
      serverData.organization = this.company._id;
      fetch(`${config.API_URL}/sharePortfolio`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: serverData,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          this.SharingCompanySubmit = false;
          this.shareCompanyModalShow = false;
          this.tags = [];
        });
    },
    getPeopleImageUrl(item) {
      return item.hasOwnProperty("image_id") && item.image_id.length > 0
        ? `${this.config.CRUNCHBASE_IMAGE_URL}/${item.image_id}`
        : `${
            item.image && item.image.length > 0
              ? item.image
              : "/static/img/face-0.jpg"
          }`;
    },

    async getChecklist() {
      if (!this.$route.query || !this.$route.query.c) {
        return;
      }
      let data = await fetch(`${config.API_URL}/checklist`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            checklist_ids: this.$route.query.c
          },
        }),
      });

      let successData = await data.json();
      this.portfolioChecklist = successData.success;
    },
  },
};
</script>
<style>
.buttonLayout {
  background: #ffd622 0% 0% no-repeat padding-box;
  border-radius: 5px;
  font-size: 14px;
  line-height: 17px;
  margin-top: auto;
  margin-bottom: auto;
  width: 106px;
  height: 34px;
  letter-spacing: 0px;
  color: #434343;
  opacity: 1;
  padding-top: 10px;
  text-align: center;
}

a:hover {
  text-decoration: none !important;
}

.topLayout {
  padding-left: 139px;
  padding-right: 139px;
}

.fiifiIcon {
  font-size: 32px;
  text-align: left;
  color: #ffffff;
  font-family: Comfortaa, cursive;
}

.loginText {
  font-size: 14px;
  line-height: 17px;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 26px;
}

.company-profile-top {
  padding-top: 27px;
  padding-bottom: 15px;
  position: relative;
}

.company-profile-top-parent {
  position: absolute;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  width: 100%;
}

.company-profile-badge {
  height: 20px !important;
  text-shadow: 0px 0px 3px #00000057 !important;
  font-size: 10px !important;
  line-height: 12px !important;
  font-family: "custom-helvetica-medium", "roboto" !important;
  padding-top: 0.26rem !important;
}

.companyProfileStatusBadgeValue {
  letter-spacing: 0px;
  color: #00000098;
  opacity: 1;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 10px;
  padding-right: 10px;
}

.company-profile-name {
  color: #000000 !important;
  font-size: 16px !important;
  line-height: 19px !important;
  font-family: "custom-helvetica-bold", "roboto" !important;
  padding-bottom: 10px !important;
}

.company-profile-sector {
  color: #000000b2 !important;
  font-size: 12px !important;
  line-height: 14px !important;
  font-family: "custom-helvetica", "roboto" !important;
  padding-bottom: 12.5px !important;
}

.portfolio-company-left-table-data {
  table-layout: fixed;
  width: 100%;
}
.portfolio-company-left-table-data th {
  width: 110px;
  font-size: 12px;
  line-height: 32px;
  color: #000000;
  font-family: custom-helvetica, roboto;
  font-weight: normal;
  vertical-align: top;
  text-align: left;
}
.portfolio-company-left-table-data td {
  font-family: custom-helvetica-medium, roboto;
  -webkit-font-smoothing: antialiased;
  color: #0000009a;
  font-size: 12px;
  line-height: 32px;
  font-weight: normal;
  overflow: hidden;
  /* white-space: nowrap; */
  text-overflow: ellipsis;
  text-align: left;
}

.borderClass {
  border: 1px solid #eaeaea;
  opacity: 1;
  background: #ffffff 0% 0% no-repeat padding-box;
}

.companyDescriptionTitle {
  text-align: left;
  font-size: 14px;
  line-height: 17px;
  font-family: custom-helvetica-bold, roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  margin-bottom: 10px;
}

.companyDescriptionData {
  text-align: left;
  font-size: 13px;
  line-height: 18px;
  font-family: custom-helvetica, roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}

.tabulator .success-data-status i {
  background-color: #79c566;
  color: #fff;
  padding: 2px;
  border-radius: 100%;
  font-weight: bolder;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  display: inline-block;
}

.companyProfileTabulatorLayout .tabulator {
  /* height: 242px;
  min-height: 242px;
  max-height: 242px; */
  /* height: 276px;
  min-height: 276px;
  max-height: 276px; */
}

.companyProfileTabulatorLayout .tabulator .tabulator-header {
  border-top: 0 !important;
  height: 34px;
  line-height: 17px;
}

.tabulator .tabulator-header {
  font-family: "custom-helvetica-medium", "roboto";
  font-size: 10px;
  color: rgba(0, 0, 0, 0.6);
  line-height: 28px;
  text-transform: uppercase;
  border-top: 0px solid transparent;
  border-bottom: 1px solid #dee2e6;
}

.todos-table-parent .tabulator .tabulator-header {
  border-bottom: 1px solid #dee2e6;
}

.companyProfileTabulatorLayout .tabulator .tabulator-headers {
  min-height: 34px;
  height: 34px;
  max-height: 34px;
}

.tabulator .tabulator-tableHolder {
  overflow-y: hidden;
  overflow-x: auto;
  font-family: "custom-helvetica-medium", "roboto";
  font-size: 14px;
  line-height: 35px;
}

.todos-table-parent .tabulator-row {
  height: 46px;
  line-height: 22px;
}

.tabulator .tabulator-row {
  -webkit-transition: background 0.3s ease 0s !important;
  transition: background 0.3s ease 0s !important;
  border-bottom: 1px solid #efefef;
}

.todos-table-parent .tabulator-footer {
  border-top: 0;
}

.companyProfileTabulatorLayout .tabulator-footer {
  padding-top: 0;
  padding-right: 0;
}

.tabulator .tabulator-footer .tabulator-paginator {
  font-size: 12px;
}

.tabulator .tabulator-footer .tabulator-page {
  height: 30px;
  line-height: 12px;
}

.tabulator .tabulator-footer .tabulator-page.active {
  border-color: #e2e2e2;
  background-color: #fff;
  color: #5445f3;
}

.tabulator .tabulator-footer {
  border-top: 2px solid transparent;
}

.tabulator-page-size {
  margin: 0 20px 0 10px;
  height: 40px;
  border: 1px solid #dee2e6;
}

.tabulator .tabulator-row:hover {
  background-color: rgba(84, 69, 243, 0.1) !important;
}

.tabulator .tabulator-footer .tabulator-paginator label {
  text-transform: capitalize !important;
  color: #6c757d !important;
}

.tabulator .tabulator-footer .tabulator-page-size {
  height: 30px;
  color: #6c757d;
}

.tabulator .tabulator-footer .tabulator-page {
  height: 30px;
  line-height: 12px;
}

.companyProfileTabulatorLayout .tabulator-arrow {
  display: none !important;
}

.companyProfileTabulatorLayout
  .tabulator
  .tabulator-header
  .tabulator-col
  .tabulator-col-content
  .tabulator-col-title {
  font-size: 10px;
  color: #757575;
  line-height: 12px;
}

.companyProfileTabulatorTitle {
  padding: 15px 0px 0px;
  padding-left: 5px;
  color: #5a5d71;
  font-size: 16px;
  font-family: "custom-helvetica-bold", "roboto";
  line-height: 19px;
  padding-bottom: 15.5px;
  text-align: left;
}

.companyProfileTabulatorTitleBorderLine {
  border: 0.8px solid #0000000d;
  opacity: 1;
}

.fundingRoundsLayout {
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #eaeaea;
  border-radius: 2px;
  opacity: 1;
  padding-bottom: 15px;
  padding-left: 20px;
  padding-right: 20px;
}

.contactsTitle {
  text-align: left;
  font-size: 12px;
  line-height: 15px;
  font-family: custom-helvetica-medium, roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
  padding-bottom: 10px;
}

.contactsName {
  text-align: left;
  font-size: 12px;
  line-height: 30px;
  font-family: custom-helvetica, roboto;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}

.contactsMore {
  text-align: left;
  text-decoration: underline;
  font-size: 14px;
  line-height: 16px;
  font-family: custom-helvetica, roboto;
  letter-spacing: 0px;
  color: #4338ae;
  opacity: 1;
  cursor: pointer;
}

.el-dialog {
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 4px;
}

.el-dialog__header {
  padding: 20px 20px 10px;
  font-size: 18px;
  line-height: 23px;
  font-family: "custom-helvetica-medium", "roboto";
  text-align: left;
}

.el-dialog__title {
  font-family: "custom-helvetica-medium", "roboto";
}

.el-dialog__body {
  padding: 8px 20px;
  color: #000000;
  letter-spacing: 0px;
  opacity: 1;
  line-height: 16px;
  font-size: 13px;
  font-family: "custom-helvetica-medium", "roboto";
  text-align: left;
}

.form-group {
  margin-bottom: auto;
}

.form-control {
  border: 1px solid #868686 !important;
  margin-top: 4px;
  margin-bottom: 10px;
  background-color: #ffffff;
  border-radius: 4px;
  font-size: 0.875rem !important;
  color: #565656;
  padding: 8px 12px;
  height: 40px;
  -webkit-box-shadow: none;
  box-shadow: none;
}

.form-control:focus {
  border-color: #868686 !important;
  box-shadow: none !important;
}

.b-form-tags-button {
  display: none !important;
}

.b-form-tag {
  background: #ededed 0% 0% no-repeat padding-box !important;
  border-radius: 12px !important;
  color: black !important;
  height: 24px !important;
  font-size: 12px !important;
}

.todo-form-cancel-button {
  width: 125px;
  height: 35px;
  color: #707070;
  background-color: #fff;
  border-radius: 4px;
  border: 1px solid #707070;
}

.btn {
  border-color: #5445f3 !important;
  background-color: #5445f3 !important;
}

.btn-wd {
  min-width: 140px;
}

.invalid-feedback {
  margin-top: 0 !important;
  font-size: 10 !important;
}

.tabulator-placeholder span {
  color: #707070 !important;
  font-weight: 300 !important;
  font-size: 16px !important;
}
.checklist-name {
  text-align: left;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0px;
  color: #000000;
  opacity: 1;
}
.checklist-description {
  text-align: left;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0px;
  color: #000000;
  opacity: 0.5;
}
.task {
  text-align: left;
  font-size: 14px;
  letter-spacing: 0px;
  color: #000000;
  opacity: 0.5;
  margin-left: 10px;
}

.task a{
  word-break: break-all;
}

</style>